export function validateEmail(email) {
  const re =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}))$/
  return re.test(String(email).toLowerCase())
}
export function validatePhone(phone) {
  const re = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/
  return re.test(String(phone).toLowerCase())
}
export function validateMobile(number) {
  const re = /^[+]?[0-9 ]*$/

  return re.test(String(number).toLowerCase())
}

export const passwordRegex = `^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*\\-\\(\\)~\\{\\[=+_.,;:'"\`“\\\`]).{8,100}$`

export function checkPassword(value, charLength, capitalLetter, numberEntered, specialChar) {
  const newState = {
    charLength,
    capitalLetter,
    numberEntered,
    specialChar,
  }

  if (value.length >= 8) {
    if (!charLength) {
      newState.charLength = true
    }
  } else if (charLength) {
    newState.charLength = false
  }

  if (value.match(/\d+/g)) {
    if (!numberEntered) {
      newState.numberEntered = true
    }
  } else if (numberEntered) {
    newState.numberEntered = false
  }

  if (value.match(/[A-Z]/g)) {
    if (!capitalLetter) {
      newState.capitalLetter = true
    }
  } else if (capitalLetter) {
    newState.capitalLetter = false
  }

  if (value.match(/[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?`~]/g)) {
    if (!specialChar) {
      newState.specialChar = true
    }
  } else if (specialChar) {
    newState.specialChar = false
  }
  return newState
}
